import { render, staticRenderFns } from "./UserHeaderButton.vue?vue&type=template&id=d6d705da&"
import script from "./UserHeaderButton.vue?vue&type=script&lang=js&"
export * from "./UserHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports